// Copyright (c) 2019 Deere & Company

import './app-greeting.scss';
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { TextDropdown } from '../../../../shared/components/text-drop-down/text-dropdown';
import { connect } from 'react-redux';
import { withAuth } from '@okta/okta-react';

export class AppGreeting extends Component {

    logout = () => {
        this.props.auth.logout('/');
    };

    render() {
        const { userDetails } = this.props;

        return (
            <div className="app-greeting">
                <span className="hi">Hi</span>

                <span className="user-name">
                    {userDetails ? (
                        <TextDropdown text={userDetails}>
                            <NavLink
                                id="1"
                                activeClassName="active"
                                to={{ pathname: '/preference', state: 'preferences' }}
                            >
                                My Preferences
                            </NavLink>

                            <span id="100" onClick={this.logout}>
                                Logout
                            </span>
                        </TextDropdown>
                    ) : (
                        <span>Guest</span>
                    )}
                </span>
            </div>
        );
    }
}

AppGreeting.propTypes = {
    userDetails: PropTypes.string,
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    userDetails: state?.oktaState?.oktaState?.userFirstName || '',
});

export default connect(
    mapStateToProps
)(withAuth(AppGreeting));